<template>
	<v-tabs 
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
		<v-tab key="Azioni" ripple class="secondary-tab">
			Azioni
		</v-tab>
		<v-tab key="Categorie" ripple class="secondary-tab">
			Categorie
		</v-tab>

		<v-tab-item class="pb-offset background-1 pt-3" key="Campi">
			<v-row class="ma-0 pb-offset">
				
				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector model-def="opportunity"></fields-selector>
				</v-col>

			</v-row>
		</v-tab-item>
		
		<v-tab-item class="pb-offset background-1 pt-3" key="Azioni">
			<v-row class="ma-0 pb-offset">
				
				<v-col class="pa-0 pt-2" cols="12">
					<actions-selector model-def="opportunity"></actions-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Categorie">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
                    <crud
                        title="Stato Opportunità"
                        action-icon='settings'
                        model-def='generaltypes-opportunity_status'
                        action-position='absolute'
                        crudDialog
                    ></crud>
				</v-col>
			</v-row>
		</v-tab-item>

	</v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import SelectorFields from '@/components/common/SelectorFields'
import ActionsSelector from '@/components/common/ActionsSelector'
import FieldsFormSelector from '@/components/common/FieldsFormSelector'

	export default {
		name:'opportunities-settings',
        components: {
			FieldsSelector,
			SelectorFields,
			ActionsSelector,
			FieldsFormSelector,
        },		
		data() {
			return {

			}
		},
	}
  </script>
